export default __webpack_public_path__ + "static/media/29.2c507a78.gif";